import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import ReadMore from 'components/Components/UI/ReadMore';
import getFinalAttribute from 'utils/alternative-attribute';

function HotelDestinationSection({ hotel })
{
    return (
        <section className="tw-pb-10 lg:tw-pb-20 tw-px-4 tw-bg-gray-300">
            <div className="xl:tw-container tw-text-center">
                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap lg:tw-justify-center">
                        <div className="tw-w-full lg:tw-w-2/3">
                            <h4 className="tw-uppercase font-sp">About The Destination</h4>
                            <ReadMore textClass="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6 tw-mt-12" max={300}>
                                {getFinalAttribute(hotel.destination, 'description').replace(/(<([^>]+)>)/ig, ' ')}
                            </ReadMore>
                        </div>
                    </div>
                </Fade>
            </div>
        </section>
    );
}

HotelDestinationSection.propTypes = {
    hotel: PropTypes.object.isRequired,
};

export default HotelDestinationSection;
